import * as React from 'react';

import {find as findLinks} from 'linkifyjs';

type Segment = {type: 'text'; value: string} | {type: 'link'; value: string};

function splitByLinks(text: string): Segment[] {
    const links = findLinks(text);
    if (!links.length) {
        return [{type: 'text', value: text}];
    }

    const segments: Segment[] = [];
    let remaining = text;

    for (const link of links) {
        const index = remaining.indexOf(link.value);
        if (index === -1) continue;

        if (index > 0) {
            segments.push({type: 'text', value: remaining.substring(0, index)});
        }
        segments.push({type: 'link', value: link.value});
        remaining = remaining.substring(index + link.value.length);
    }

    if (remaining.length > 0) {
        segments.push({type: 'text', value: remaining});
    }

    return segments;
}

/**
 * Finds links in a string and styles them as such without returning a functional link.
 */
export const linkifyStyle = (string: string): React.ReactElement => {
    const segments = splitByLinks(string);

    return (
        <>
            {segments.map((segment, i) =>
                segment.type === 'link' ? (
                    <span key={i} style={{textDecoration: 'underline', color: '#3b9eD7'}}>
                        {segment.value}
                    </span>
                ) : (
                    <React.Fragment key={i}>{segment.value}</React.Fragment>
                )
            )}
        </>
    );
};
